export const bookingLogsColumns = [
  {
    Header: "Performed By",
    accessor: "first_name",
  },
  {
    Header: "Email",
    accessor: "email",
  },
  {
    Header: "Phone",
    accessor: "phone",
  },
  {
    Header: "Action",
    accessor: "action",
  },
  {
    Header: "Time",
    accessor: "time",
  },
  {
    Header: "Remarks",
    accessor: "remarks",
  },
];
